(function () {
    var openBtn = document.getElementById('open-configurator');
    var hullaFullContainer = document.getElementById('full-container-hulla');
    var closeBtn = document.getElementById('close-configurator');
    var closeBound = false;

    if (!openBtn || !hullaFullContainer) {
      return;
    }

    function refreshProductGallerySliders() {
      if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
        return;
      }

      jQuery('#quickview_product .product-images-content .slick-initialized').each(function () {
        jQuery(this).slick('setPosition');
      });
    }

    function scrollToHullaTop() {
      var target = document.getElementById('hulla-with-closeBtn') || document.getElementById('hulla-container');
      if (!target) {
        return;
      }
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function openConfigurator() {
      document.body.classList.add('hulla-config');
      hullaFullContainer.style.display = 'block';
      hullaFullContainer.offsetHeight;
      hullaFullContainer.classList.add('is-visible');

      if (window.matchMedia('(max-width: 767px)').matches) {
        requestAnimationFrame(function () {
          scrollToHullaTop();
          setTimeout(scrollToHullaTop, 350);
        });
      }
    }

    function closeConfigurator() {
      hullaFullContainer.classList.remove('is-visible');

      function finishClose() {
        hullaFullContainer.style.display = 'none';
        document.body.classList.remove('hulla-config');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            refreshProductGallerySliders();
            window.dispatchEvent(new Event('resize'));
          });
        });
      }

      var onTransitionEnd = function (event) {
        if (event.target !== hullaFullContainer || event.propertyName !== 'opacity') {
          return;
        }
        hullaFullContainer.removeEventListener('transitionend', onTransitionEnd);
        finishClose();
      };

      hullaFullContainer.addEventListener('transitionend', onTransitionEnd);
      setTimeout(function () {
        hullaFullContainer.removeEventListener('transitionend', onTransitionEnd);
        if (hullaFullContainer.style.display !== 'none') {
          finishClose();
        }
      }, 400);
    }

    openBtn.addEventListener('click', openConfigurator);

    if (closeBtn && !closeBound) {
      closeBound = true;
      closeBtn.addEventListener('click', closeConfigurator);
    }
  })();